import React from 'react';

/**
 * Status, as a word plus a shape — never colour alone (dataviz skill,
 * palette.md). Colour-blind readers and greyscale screenshots both have to
 * survive this, and an ops panel gets screenshotted into Slack constantly.
 */
const TONES = {
  good: 'bg-status-good/10 text-status-good',
  warning: 'bg-status-warning/15 text-[#8a5a00]',
  serious: 'bg-status-serious/15 text-[#9c4a21]',
  critical: 'bg-status-critical/10 text-status-critical',
  neutral: 'bg-surface-page text-ink-secondary',
  info: 'bg-accent-50 text-accent-600',
};

/** Maps the enums the backend actually returns onto a tone + label. */
export const STATUS_MAP = {
  // crawl / job
  queued: ['neutral', 'Queued'],
  running: ['info', 'Running'],
  succeeded: ['good', 'Succeeded'],
  failed: ['critical', 'Failed'],
  not_started: ['neutral', 'Not started'],
  // partner account
  pending_review: ['warning', 'Pending review'],
  active: ['good', 'Active'],
  rejected: ['critical', 'Rejected'],
  suspended: ['serious', 'Suspended'],
  // crawl probe
  passed: ['good', 'Probe passed'],
  warning: ['warning', 'Probe warning'],
};

export default function StatusPill({ status, tone, label, className = '' }) {
  const [mappedTone, mappedLabel] = STATUS_MAP[status] || [];
  const t = tone || mappedTone || 'neutral';
  const text = label || mappedLabel || status || '-';
  return (
    <span
      className={`inline-flex items-center gap-1.5 whitespace-nowrap rounded-full px-2 py-0.5 text-[11px] font-semibold ${TONES[t]} ${className}`}
    >
      <svg width="6" height="6" viewBox="0 0 8 8" fill="currentColor" aria-hidden="true">
        <circle cx="4" cy="4" r="4" />
      </svg>
      {text}
    </span>
  );
}
